<template>
  <div id="stores">
    <div class="header flex-between">
      <div class="header-text">
        <h1>条件分组</h1>
      </div>
      <div class="header-button">
        <el-button v-if="jurisdiction.search"
                   icon="iconfont icon-sousuo1"
                   plain
                   @click="searchList">{{
          searchBtnText
        }}</el-button>
        <el-button v-if="jurisdiction.create"
                   icon="iconfont icon-chuangjian1"
                   plain
                   @click.native="goToConditional(1)">{{ insertBtnText }}</el-button>
        <el-button v-if="jurisdiction.copy"
                   icon="el-icon-edit-outline"
                   @click.native="goToConditional(2)"
                   plain>{{ copeBtnText }}</el-button>
        <el-button v-if="jurisdiction.modify"
                   icon="iconfont icon-xiugai1"
                   @click.native="goToConditional(3)"
                   plain>{{ modifyBtnText }}</el-button>
        <el-button v-if="jurisdiction.delete"
                   icon="iconfont icon-a-shanchu11"
                   plain
                   @click="deleteBtn">{{
          deleteBtnText
        }}</el-button>
        <el-button v-if="jurisdiction.enable"
                   @click="enableChange">{{ enableBtnText }}</el-button>
        <el-button v-if="jurisdiction.disable"
                   @click="disableChange">{{ disableBtnText }}</el-button>
        <el-button v-if="jurisdiction.look"
                   icon="iconfont icon-chakan1"
                   @click="goLookDialog">{{
          lookBtnText
        }}</el-button>
      </div>
    </div>
    <!-- 搜索 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form size="small"
                 label-width="9.375rem">
          <el-row>
            <el-col :span="8">
              <el-form-item label="分组名称">
                <el-input v-model="config.custGrpName"
                          clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="分组类型">
                <el-select style="width: 100%"
                           v-model="fenZhuOptionsSelect">
                  <el-option v-for="item in fenZhuOptions"
                             :key="item.value"
                             :value="item.value"
                             :label="item.label"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-select style="width: 100%" v-model="config.state">
                  <el-option label="所有" value=""></el-option>
                  <el-option label="已启用" value="0"></el-option>
                  <el-option label="未启用" value="1"></el-option>
                  <el-option label="已无效" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            </el-row>
            <el-row>
            <el-col :span="12">
              <el-form-item label="创建日期从">
                <el-date-picker v-model="config.createDateStart"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
                至
                <el-date-picker v-model="config.createDateEnd"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never"
             class="centercard">
      <el-table size="small"
                class="table-style"
                height="600px"
                border
                :row-class-name="tableRowClassName"
                :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '.875rem',
        }"
                :cell-style="{ 'text-align': 'center' }"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                v-el-table-infinite-scroll="load"
                v-loading="loading"
                infinite-scroll-disabled="onLoading"
                @selection-change="handleSelectionChange"
                @select="handleSelectionCheck">
        <el-table-column type="selection"
                         width="45"></el-table-column>
        <el-table-column label="分组名称">
          <template slot-scope="scope">
            <div v-if="jurisdiction.look"
                 style="text-decoration: underline; color: skyblue"
                 @click="goLookDialog1(scope.row.customerGrpID)">
              {{ scope.row.custGrpName }}
            </div>
            <div v-else
                 style="text-decoration: underline; color: skyblue">
              {{ scope.row.custGrpName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="分组类型">
          <template slot-scope="scope">
            {{ scope.row.grpKind == 0 ? "公共分组" : "个人分组" }}
          </template>
        </el-table-column>
        <el-table-column prop="state"
                         label="状态">
          <template slot-scope="scope">
            {{
              scope.row.state == 0
                ? "已启用"
                : scope.row.state == 1
                ? "未启用"
                : "已无效"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName"
                         label="创建人">
        </el-table-column>
        <el-table-column prop="createTime"
                         label="创建日期">
          <template slot-scope="scope">
            <div v-if="scope.row.createTime">
              {{ scope.row.createTime | dateFormats }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="updateUserName"
                         label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTime"
                         label="最后修改日期">
          <template slot-scope="scope">
            <div v-if="scope.row.updateTime">
              {{ scope.row.updateTime | dateFormats }}
            </div>
            <div v-else></div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 创建弹窗 -->
    <con-dialog ref="conDialogRef"></con-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import conDialog from "./conDialog.vue";
import { getcpyNo } from "@/utils/auth";
import { queryLSelectApi } from "@/api/user"; // 会员等级接口
import {
  groundPageApi,
  lookGroundApi,
  deleteApi,
  enableApi,
  disableApi,
} from "@/api/marketing";
export default {
  name: "centre",
  components: {
    conDialog,
  },
  data () {
    return {
      jurisdiction: {
        search: false,
        create: false,
        copy: false,
        modify: false,
        delete: false,
        enable: false,
        disable: false,
        look: false,
      },
      radio: "",
      loading: false,
      examineVisible: false,
      createVisible: false,
      labelPosition: "top",
      queryInfoTable: {}, //列表请求数据
      lookGroundInfo: {}, // 查看组信息
      lookGroundLine: [], // 查看组信息
      lookGroundShops: [], // 查看组信息
      SelectChang: {}, //选择的数据
      //搜索
      fenZhuOptionsSelect: "", //分组
      fenZhuOptions: [
        {
          value: "",
          label: "所有",
        },
        {
          value: "0",
          label: "公共分组",
        },
        {
          value: "1",
          label: "个人分组",
        },
      ],
      config: {
        pageNo: 1,
        pageSize: 50,
        pagesTotal: 0,
        total: 0,
        custGrpName: "",
        state:"",
        createDateStart: undefined,
        createDateEnd: undefined,
        grpMode: 1, // 条件分组
      },
      tableData: [],
      // groundData: {},
      // lineData: [], //条件字段
      // shopsData: [], //选择门店数据
    };
  },
  created () {
    this.tableList();
    let ConditionalGrouping = JSON.parse(localStorage.getItem("ConditionalGrouping"))
    for (let i = 0; i < ConditionalGrouping.length; i++) {
      if (ConditionalGrouping[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (ConditionalGrouping[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (ConditionalGrouping[i].menuName == "复制") {
        this.jurisdiction.copy = true;
        continue;
      }
      if (ConditionalGrouping[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (ConditionalGrouping[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (ConditionalGrouping[i].menuName == "启用") {
        this.jurisdiction.enable = true;
        continue;
      }
      if (ConditionalGrouping[i].menuName == "禁用") {
        this.jurisdiction.disable = true;
        continue;
      }
      if (ConditionalGrouping[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
    //console.log(ConditionalGrouping)
  },
  computed: {
    isMore () {
      return this.config.pageNo >= this.config.pagesTotal;
    },
    onLoading () {
      return this.loading || this.isMore;
    },
    ...mapState([
      "searchBtnText",
      "insertBtnText",
      "copeBtnText",
      "modifyBtnText",
      "deleteBtnText",
      "enableBtnText",
      "disableBtnText",
      "lookBtnText",
    ]),
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 创建/修改/复制弹窗
    goToConditional (index) {
      //console.log(index);
      if (index == 1) {
        this.$refs.conDialogRef.title = "会员分组-条件分组-创建";
        this.$refs.conDialogRef.open = true;
        this.$refs.conDialogRef.id = index;
        queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
          this.$refs.conDialogRef.checkbooksData = res.data;
          // console.log(this.$refs.conDialogRef.checkbooksData);
        });
      } else if (index == 2) {
        if (Object.keys(this.SelectChang) < 2) {
          this.$message({
            message: "请选择数据!",
            type: "warning",
          });
        } else {
          lookGroundApi({
            customerGrpID: this.SelectChang.customerGrpID,
          }).then((res) => {
            // console.log(res, 111);
            if (res.success) {
              queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
                this.$refs.conDialogRef.checkbooksData = res.data;
              });
              this.$refs.conDialogRef.title = "会员分组-条件分组-复制";
              this.$refs.conDialogRef.open = true;
              this.$refs.conDialogRef.id = index;
              let list = []; //后端数据返回不够不数据
              let str = {
                condiField: "",
                condiOP: "",
                customerGrpID: "",
                id: "",
                value1: "",
                value2: "",
              };
              for (let i = 0; i < 12; i++) {
                if (i == 0) {
                  str.value2 = 1;
                }
                list.push(str);
              }

              const { grpinfo } = res.data;
              this.$refs.conDialogRef.form.line = list;
              this.$refs.conDialogRef.form.grpinfo = grpinfo;
              // list.forEach((item, index) => {
              //   let listIndex = index;
              //   res.data.line.forEach((item, index) => {
              //     console.log(item.condiField, "item2", index);
              //     if (item.condiField - 1 == listIndex) {
              //       list[listIndex] = item;
              //     }
              //   });
              // });
              // res.data.line[0].value2 = Number(res.data.line[0].value2);
              // res.data.line[1].value2 = Number(res.data.line[1].value2);
              // res.data.line = list;
              // this.$refs.conDialogRef.form = res.data;
              // console.log(res.data.line[2].value1.split(";").map(Number), 22);
              // this.$refs.conDialogRef.levelList = res.data.line[2].value1
              //   .split(";")
              //   .map(Number);
              this.$nextTick(() => {
                this.$refs.conDialogRef.updata(res.data);
              });
              if(res.data.shops[0]!=null) {
                this.$refs.conDialogRef.form.line[0].value1 =
                    res.data.shops[0].custGrpLineShopVO.map((item) => {
                      return item.shopName;
                    });
              }
            }
          });
        }
      } else {
        if (Object.keys(this.SelectChang) < 2) {
          this.$message({
            message: "请选择数据!",
            type: "warning",
          });
        } else {
          queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
            this.$refs.conDialogRef.checkbooksData = res.data;
          });

          lookGroundApi({
            customerGrpID: this.SelectChang.customerGrpID,
          }).then((res) => {
            this.$refs.conDialogRef.title = "会员分组-条件分组-修改";
            this.$refs.conDialogRef.open = true;
            this.$refs.conDialogRef.id = index;

            var list = []; //后端数据返回不够补数据

            let str = {
              condiField: "",
              condiOP: "",
              customerGrpID: "",
              id: "",
              value1: "",
              value2: "",
            };
            for (let i = 0; i < 13; i++) {
              if (i == 0) {
                str.value2 = 1;
              }
              list.push(str);
            }

            const { grpinfo } = res.data;
            this.$refs.conDialogRef.form.line = list;
            this.$refs.conDialogRef.form.grpinfo = grpinfo;

            this.$nextTick(() => {
              this.$refs.conDialogRef.updata(res.data);
            });

            if(res.data.shops[0]!=null){
            this.$refs.conDialogRef.form.line[0].value1 =
              res.data.shops[0].custGrpLineShopVO.map((item) => {
                return item.shopName;
              });
            }

          });
        }
      }
    },
    // 查看
    goLookDialog () {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          message: "请选择数据!",
          type: "warning",
        });
      } else {
        localStorage.setItem("lookId", this.SelectChang.customerGrpID);
        this.$router.push("/conditionallook");
      }
    },
    goLookDialog1 (index) {
      localStorage.setItem("lookId", index);
      this.$router.push("/conditionallook");
    },
    handleSelectionChange (e) {
      if (e.length > 0) {
        this.SelectChang = e[e.length - 1];
      } else {
        this.SelectChang = {};
      }
      // console.log(e)
    },
    handleSelectionCheck (selection, row) {
      this.$refs.multipleTable.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.SelectChang = row;
        this.$refs.multipleTable.toggleRowSelection(row, true);
        // this.lookGround();
      }
      // console.log(row);
    },
    // 列表数据
    tableList () {
      let queryInfoTable = {
        pageNo: this.config.pageNo,
        pageSize: this.config.pageSize,
        custGrpName: this.config.custGrpName,
        state: this.config.state,
        grpKind: this.fenZhuOptionsSelect,
        createDateStart: this.config.createDateStart,
        createDateEnd: this.config.createDateEnd,
        grpMode: this.config.grpMode,
      };
      groundPageApi(require("qs").stringify(queryInfoTable)).then((res) => {
        if (res.message == "success") {
          //  console.log(res)
          if (this.config.pageNo == 1) {
            this.tableData = res.data.list;
          } else {
            this.tableData = this.tableData.concat(res.data.list);
          }
          this.config.pageSize = res.data.pageSize;
          this.loading = false;
        }
      });
    },
    // 查询
    searchList () {
      this.tableData = [];
      this.config.total = 0;
      this.config.pageNo = 1;
      this.tableList();
    },
    load () {
      this.loading = true;
      setTimeout(() => {
        this.config.pageNo += 1;
        this.tableList();
      }, 500);
    },
    // 创建
    createData () { },
    // 修改
    fenZu () { },
    // 删除
    deleteBtn () {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          showClose: true,
          message: "请选择数据,再删除!",
          type: "warning",
        });
      } else {
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          deleteApi({ customerGrpID: this.SelectChang.customerGrpID }).then(
            (res) => {
              if (res.message) {
                this.$message.success("删除成功!");
                this.tableData = [];
                this.config.total = 0;
                this.config.pageNo = 1;
                this.tableList();
              }
            })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "取消删除！",
          });
        });
      }
    },
    // 启用
    enableChange () {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
      } else {
        this.$confirm("是否启用?", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          let enableA = {
            customerGrpID: this.SelectChang.customerGrpID,
          };
          enableApi(require("qs").stringify(enableA)).then((res) => {
            if (res.message) {
              this.$message.success("已启用");
              this.tableData = [];
              this.config.total = 0;
              this.config.pageNo = 1;
              this.tableList();
            }
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "取消操作！",
          });
          // } else {
          //   this.$message.error("当前无效状态，不能修改!");
        });
      }
    },
    // 禁用
    disableChange () {
      if (Object.keys(this.SelectChang) < 2) {
        this.$message({
          message: "请选择数据",
          type: "warning",
        });
      } else {
        this.$confirm("是否禁用?", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          let enableB = {
            customerGrpID: this.SelectChang.customerGrpID,
          };
          disableApi(enableB).then((res) => {
            if (res.message) {

              this.$message.success("已禁用");
              this.tableData = [];
              this.config.total = 0;
              this.config.pageNo = 1;
              this.tableList();
            }
          })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消操作！",
              });
            });

        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#stores {
  // height: 1350px;
  height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
.push-button {
  background-color: #e9e7d3;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
}
</style>
